module.exports = __webpack_public_path__ + "static/media/6.2eb74faa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/6.jpg
// module id = 93
// module chunks = 0